<div class="clearfix">
  <div class="flex flex-wrap">
    <div class="sm-col-6 md-col-6">
      <form [formGroup]="formGroup">
        <mat-grid-list cols="1" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Documentation Type</mat-label>
              <mat-select (selectionChange)="onDocumentationTypeSelected($event.source.value)"
                          [formControlName]="controls.DocumentationType">
                <mat-option *ngFor="let documentationType of documentationTypeLookUpValues"
                            [value]="documentationType">
                  {{documentationType}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Documentation Type')">help_outline</mat-icon>
          </mat-grid-tile>
          
          <!---------------------------------------->
          <!--General Documentation-->
          <!---------------------------------------->
          
          <mat-grid-tile
            *ngIf="formGroup.get(controls.DocumentationType).value === documentationType.GeneralDocumentation">
            <!-- Free text field -->
            <mat-form-field>
              <mat-label>Document Description</mat-label>
              <input (input)="onInputChangedUpdateDescription()" [formControlName]="controls.Description" matInput
                     required
                     type="text">
              <button (click)="onClearDescription($event)"
                      *ngIf="formGroup.controls[controls.Description].value"
                      aria-label="Clear" mat-button mat-icon-button matSuffix>
                <mat-icon style="color: grey;">clear</mat-icon>
              </button>
              
              <mat-error *ngIf="formGroup.controls[controls.Description].touched &&
                                formGroup.controls[controls.Description].invalid">
                Please input the document description.
              </mat-error>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Documentation Description')">help_outline
            </mat-icon>
          </mat-grid-tile>
          
          <!---------------------------------------->
          <!--Workmen Compensation Documentation-->
          <!---------------------------------------->
          
          <mat-grid-tile
            *ngIf="formGroup.get(controls.DocumentationType).value === documentationType.WorkmenCompensationDocumentation">
            <mat-form-field>
              <mat-select [formControlName]="controls.WorkmanCompensationDocumentation"
                          (selectionChange)="onWorkmenCompensationLookUpValueSelected($event.source.value)">
                <mat-option
                  *ngFor="let workmanCompensationDocumentation of workmanCompensationDocumentationLookUpValues"
                  [value]="workmanCompensationDocumentation.value">
                  {{workmanCompensationDocumentation.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-grid-tile>
          
          <!---------------------------------------->
          <!--Road Accident Fund Documentation-->
          <!---------------------------------------->
          
          <mat-grid-tile
            *ngIf="formGroup.get(controls.DocumentationType).value === documentationType.RoadAccidentFundDocumentation">
            <mat-form-field>
              <mat-select [formControlName]="controls.RoadAccidentFundDocumentation"
                          (selectionChange)="onRoadAccidentLookUpValueSelected($event.source.value)">
                <mat-option *ngFor="let roadAccidentFundDocumentation of roadAccidentFundDocumentationLookUpValues"
                            [value]="roadAccidentFundDocumentation.value">
                  {{roadAccidentFundDocumentation.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </mat-grid-tile>
          
          <mat-grid-tile>
            <app-file-upload [config]="fileUploadConfig"
                             [disabled]="disableUploadBtn"
                             [iconName]="'attach_file'"
                             [showIcon]="true"
                             (onUploadSuccess)="onFileUploadSuccess($event)">
            </app-file-upload>
          
          </mat-grid-tile>
        </mat-grid-list>
      </form>
    </div>
    <div class="sm-col-6 md-col-6">
      
      <ng-container *ngIf="caseHospitalFiles?.length === 0 else showDocumentationsSections">
        <h4 class="mat-primary-color">Upload a document using the controls on the left</h4>
      </ng-container>
      
      <ng-template #showDocumentationsSections>
        
        <!---------------------------->
        <!--Section: General Documentation-->
        <!---------------------------->
        
        <section *ngIf="generalDocumentation?.length" class="documentation-section">
          <ng-container [ngTemplateOutletContext]="{
                    documentationType: documentationType.GeneralDocumentation,
                    documentationList: generalDocumentation}"
                        [ngTemplateOutlet]="documentationTemplate">
          </ng-container>
        </section>
        
        <!---------------------------->
        <!--Section: Workmen’s Compensation Documentation-->
        <!---------------------------->
        
        <section *ngIf="workmanCompensationDocumentation?.length" class="documentation-section">
          <ng-container [ngTemplateOutletContext]="{
                     documentationType: documentationType.WorkmenCompensationDocumentation,
                     documentationList: workmanCompensationDocumentation}"
                        [ngTemplateOutlet]="documentationTemplate">
          </ng-container>
        </section>
        
        
        <!---------------------------->
        <!--Section: Road Accident Fund Documentation-->
        <!---------------------------->
        
        <section *ngIf="roadAccidentFundDocumentation?.length" class="documentation-section">
          <ng-container [ngTemplateOutletContext]="{
                    documentationType: documentationType.RoadAccidentFundDocumentation,
                    documentationList: roadAccidentFundDocumentation}"
                        [ngTemplateOutlet]="documentationTemplate">
          </ng-container>
        </section>
      </ng-template>
    </div>
  </div>
</div>

<!---------------------------->
<!--Navigation Buttons-->
<!---------------------------->

<div class="button-container">
  <button color="primary" mat-raised-button matStepperPrevious>Back</button>
  <button (click)="clearFilesLinkDTOList()" color="warn" mat-raised-button>Clear</button>
  <button color="primary" mat-raised-button matStepperNext>Next</button>
</div>


<!---------------------------->
<!--Documentation Template-->
<!---------------------------->
<ng-template #documentationTemplate
             let-documentationList="documentationList"
             let-documentationType="documentationType">
  <h4 class="mat-primary-color">{{documentationType}}</h4>
  
  <ng-container *ngFor="let document of documentationList">
    <ng-container *ngIf="document?.file">
      <div class="flex flex-wrap">
        <div class="col-4">
          <p>{{document?.file?.description}}</p>
        </div>
        <div class="col-5">
          <a (click)="downloadFile($event, document)" href="#" target="_blank">
            {{document?.file?.name}}{{document?.file?.extension}}
          </a>
        </div>
        <div class="col-3">
          <mat-icon (click)="onDeleteDocumentation($event, documentationType, document)"
                    class="mat-primary-color hand-cursor m-l-10 m-r-10"
                    matTooltip="DELETE">
            delete
          </mat-icon>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
